import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useWindowResize from "@/hooks/useWindowResize"
import FilterComponent from "@/components/Shared/VisualNav/FilterComponent"
import { dataLayerForForArrows } from "@/components/Shared/VisualNav/analytics/index"
import {
  selectProductListState,
  setVisualNavAppliedFilters,
} from "@/store/features/productListSlice"
import { PDP_SLIDER_SIZES } from "@/constants/index"
import {
  LEFT_ARROW,
  RIGHT_ARROW,
} from "@/components/Shared/VisualNav/analytics/constant"
import styles from "@/components/Shared/VisualNav/index.module.scss"
import { DOUBLE_QUOTE_REGEX } from "@/constants/regex"

const VisualNavigation = (data = {}) => {
  const dispatch = useDispatch()
  const productlistState = useSelector(selectProductListState)
  const {
    visualNavAppliedFilters = [],
    visualNavFiltersInitialLoad = false,
    plp: { currentAppliedfilters = [] } = {},
  } = productlistState
  const [width] = useWindowResize()
  const myAuthoredData = data?.data[":items"]
  const listOfFilters = myAuthoredData
  const [currentIndex, setCurrentIndex] = useState(0)
  const [productsPerView, setProductsPerView] = useState(1)
  const [selectedNav, setSelectedNav] = useState([])
  const sliderRef = useRef(null)
  const productArray = Object.values(listOfFilters)
  const { visualNavPlp } = PDP_SLIDER_SIZES
  const [isMobile, setIsMobile] = useState(width <= PDP_SLIDER_SIZES)

  useEffect(() => {
    setIsMobile(width <= visualNavPlp)
    const calculateProductsPerView = () => {
      if (sliderRef.current) {
        const containerWidth = sliderRef.current.offsetWidth
        const productWidth = 335
        if (productWidth) {
          setProductsPerView(Math.floor(containerWidth / productWidth))
        }
      }
    }
    calculateProductsPerView() // Initial calculation
    window.addEventListener("resize", calculateProductsPerView) // Recalculate on resize
    return () => {
      window.removeEventListener("resize", calculateProductsPerView)
    }
  }, [])

  const handleNext = () => {
    setCurrentIndex(prevIndex =>
      prevIndex + 1 >= productArray.length ? 0 : prevIndex + 1
    )
    dataLayerForForArrows("right")
  }

  const handlePrevious = () => {
    setCurrentIndex(prevIndex =>
      prevIndex === 0 ? Math.max(0, productArray.length - 1) : prevIndex - 1
    )
    dataLayerForForArrows("left")
  }

  const clearVisualNavFilterSelection = () => {
    setSelectedNav([])
    sessionStorage.removeItem("filterName")
  }

  const getIsVisualNavAppliedOrSelected = (productArray = []) => {
    if (!currentAppliedfilters.length || visualNavFiltersInitialLoad) {
      return
    }
    let isFilterNavFound = true
    const newcondition = sessionStorage.getItem("filterName")
    productArray.forEach((navData = {}, index = -1) => {
      const { filterName = "", filterValue = "" } = navData
      const filteredValue = filterValue?.replace(DOUBLE_QUOTE_REGEX, '\\"')
      if (currentAppliedfilters.length) {
        currentAppliedfilters.forEach(filter => {
          if (
            filter?.facet === filterName &&
            filter.value.indexOf(filteredValue) > -1 &&
            filter?.value[0] === filteredValue &&
            filter?.value[0] ===
              newcondition?.replace(DOUBLE_QUOTE_REGEX, '\\"')
          ) {
            if (!isFilterNavFound) return
            setSelectedNav([index])
            dispatch(
              setVisualNavAppliedFilters([
                {
                  facet: filterName,
                  display: [filterValue],
                  value: [filteredValue],
                  add: true,
                },
              ])
            )
            isFilterNavFound = false
          }
        })
      }
    })
    if (isFilterNavFound) clearVisualNavFilterSelection()
  }

  const handleNavSelection = (index, filterName, filterValue) => {
    const filteredValue = filterValue?.replace(DOUBLE_QUOTE_REGEX, '\\"')
    if (selectedNav.includes(index)) {
      clearVisualNavFilterSelection()
      dispatch(
        setVisualNavAppliedFilters([
          {
            facet: filterName,
            display: [filterValue],
            value: [filteredValue],
            add: false,
          },
        ])
      )
    } else {
      setSelectedNav([index])
      dispatch(
        setVisualNavAppliedFilters([
          {
            facet: filterName,
            display: [filterValue],
            value: [filteredValue],
            add: true,
          },
        ])
      )
    }
  }

  useEffect(() => {
    if (!visualNavAppliedFilters.length) {
      setSelectedNav([])
    }
  }, [visualNavAppliedFilters])

  useEffect(() => {
    getIsVisualNavAppliedOrSelected(productArray)
  }, [currentAppliedfilters])

  return (
    <div className={styles.ProductWrapper}>
      <div className="filter-conatiner" ref={sliderRef}>
        {!isMobile ? (
          <>
            {productsPerView < productArray.length ? (
              <div className="Buttons">
                <div
                  className={`slider-btn-prev${
                    currentIndex === 0 ? "-disable" : ""
                  }`}
                  onClick={currentIndex === 0 ? null : handlePrevious}
                >
                  <img alt="leftarrow" src={LEFT_ARROW}></img>
                </div>
                <div
                  className={`slider-btn-next${
                    currentIndex + productsPerView === productArray.length
                      ? "-disable"
                      : ""
                  }`}
                  onClick={
                    productArray.length - currentIndex === productsPerView
                      ? null
                      : handleNext
                  }
                >
                  <img alt="rightarrow" src={RIGHT_ARROW}></img>
                </div>
              </div>
            ) : null}
            <div
              className="plp-block"
              style={{
                transform: `translateX(-${
                  (currentIndex / productsPerView) * 100
                }%)`,
              }}
            >
              {productArray.map((product, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      key={index}
                      className="display-item"
                      style={{
                        flex: `0 0 calc(100% / ${productsPerView})`,
                      }}
                    >
                      <FilterComponent
                        data={product}
                        index={index}
                        productLength={productArray.length}
                        onNavSelection={handleNavSelection}
                        isSlected={selectedNav.includes(index)}
                      />
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
          </>
        ) : (
          <div className="plp-block">
            {productArray.map((product, index) => (
              <div key={index} className="display-item">
                <FilterComponent
                  data={product}
                  index={index}
                  productLenghth={productArray?.length}
                  onNavSelection={handleNavSelection}
                  isSlected={selectedNav.includes(index)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
export default VisualNavigation
